module.exports = __webpack_public_path__ + "img/kirbi.596e3a1d.svg";